<template>
  <div v-if="help_title != help || help_img">
    <md-icon class="justify-content-start">
      help
      <md-tooltip  :style="style_tooltip" md-direction="right">
        {{ help_title }}
        <img
          id="tooltip_img"
          v-if="help_img"
          :src="help_img"
          alt="ireal helper"
      /></md-tooltip>
    </md-icon>
  </div>
</template>

<script>
export default {
  name: "help-widget",
  props: ["help", "help_img","help_style"],
  computed: {
    help_title() {
     return this.$t(this.help);
    },
    style_tooltip() {
      var img = new Image();
      img.src = this.help_img;
      return this.help_img ? `min-width:${this.help_style};max-width:20%` : "";
    },
  }
};
</script>
<style scoped>
.md-tooltip {
  word-break: break-word;
  white-space: pre-line;
  z-index: 999999999;
  height:auto!important;
}
.md-toolbar.md-theme-default .md-icon{
  color:white !important;
}
</style>
